// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"10":"decd1c97","145":"30040e6e","204":"96c340e9","260":"2fa86fa2","560":"e7651654","586":"c7cde443","620":"755d6260","951":"4ba70801","970":"6e3c2a4e"}[chunkId] + ".chunk.css";
};